export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-brush/src/event.js
// module id = Bo4j
// module chunks = 0